import { render, staticRenderFns } from "./ObtainedLicenseRenew.vue?vue&type=template&id=310e2372&scoped=true&"
import script from "./ObtainedLicenseRenew.vue?vue&type=script&lang=js&"
export * from "./ObtainedLicenseRenew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310e2372",
  null
  
)

export default component.exports